import React from 'react'
import { useLocation } from 'react-router-dom'

function OrdersManagementIcon({ size = 28 }) {
  const location = useLocation()
  const isActive = location.pathname.startsWith('/order')
  const color = isActive ? '#FFFFFF' : '#8F9DAC'

  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.1666 25.6668C14.2121 25.6668 13.3002 25.2688 11.4764 24.4726C9.3477 23.5435 7.71811 22.8322 6.58754 22.1668H2.33331M15.1666 25.6668C16.1212 25.6668 17.0331 25.2688 18.8569 24.4726C23.3968 22.491 25.6666 21.5002 25.6666 19.8335V7.5835M15.1666 25.6668V12.8335M4.66665 7.5835V11.0835" stroke={color} stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.8803 11.3068L7.47219 9.65765C5.60185 8.75261 4.66669 8.3001 4.66669 7.5835C4.66669 6.86689 5.60185 6.41438 7.47219 5.50934L10.8803 3.86022C12.9836 2.84241 14.0354 2.3335 15.1667 2.3335C16.298 2.3335 17.3498 2.8424 19.4531 3.86022L22.8612 5.50934C24.7315 6.41438 25.6667 6.86689 25.6667 7.5835C25.6667 8.3001 24.7315 8.75261 22.8612 9.65765L19.4531 11.3068C17.3498 12.3246 16.298 12.8335 15.1667 12.8335C14.0354 12.8335 12.9836 12.3246 10.8803 11.3068Z" stroke={color} stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M21.1594 4.68506L9.17841 10.4825" stroke={color} stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M2.33331 15.1665H5.83331" stroke={color} stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M2.33331 18.6665H5.83331" stroke={color} stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export default OrdersManagementIcon
